import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=0c9c653a&scoped=true"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=0c9c653a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c653a",
  null
  
)

export default component.exports